export const LOAD_SATKPIDATA = "LOAD_SATKPIDATA";
export const LOAD_SATKPIDATA_SUCCESS = "LOAD_SATKPIDATA_SUCCESS";
export const LOAD_SATKPIDATA_ERROR = "LOAD_SATKPIDATA_ERROR";
